import { Injectable } from '@angular/core';
import { db, PdfResponse } from '../db/db-service.service';

@Injectable({
  providedIn: 'root'
})
export class CvDbService {
  async savePdf(response: PdfResponse) {
    return await db.pdfs.add(response);
  }

  async getAllPdfs(): Promise<PdfResponse[]> {
    return await db.pdfs.toArray();
  }

  async getPdfById(id: number): Promise<PdfResponse | undefined> {
    return await db.pdfs.get(id);
  }

  async deletePdf(id: number) {
    return await db.pdfs.delete(id);
  }
  async clearAllPdfs() {
    await db.pdfs.clear();
  }
  constructor() { }
}
